import { AllowedOption, TUser } from '../types/commonTypes'

export const hasPermission = (user: TUser | null, option: AllowedOption): boolean => {
  return user != null && user.allowedOptions.includes(option)
}
